import React, { Component } from 'react';

class Header extends Component {
   render() {

   //  if(this.props.data){
   //    var name = this.props.data.name;
   //    var occupation= this.props.data.occupation;
   //    var description= this.props.data.description;
   //    var city= this.props.data.address.city;
   //    var networks= this.props.data.social.map(function(network){
   //      return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
   //    })
   //  }

      return (

      <head>
         <meta name="author" content="Lauro Salazar"/>
         <meta name="description" content="Lauro Salazar's Resume website"/>
         <meta name="keywords" content="HTML, CSS, JavaScript, Cloud, Engineer, Systems Engineer, developer, vmware, f5, load balancers, infrastructure engineer, infrastructure cloud engineer, netapp, nimble"/>
         <meta http-equiv="Content-Type" content="text/html;charset=UTF-8"/> 
         <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"/>

         <link rel="shortcut icon" type="image/x-icon" href="./images/favicon.ico"/>

         <link rel="stylesheet" href="./css/vendor/bootstrap.min.css"/>
         <link rel="stylesheet" href="./css/vendor/slick.css"/>
         <link rel="stylesheet" href="./css/vendor/slick-theme.css"/>
         <link rel="stylesheet" href="./css/vendor/aos.css"/>
         <link rel="stylesheet" href="./css/plugins/feature.css"/>
      
         <link rel="stylesheet" href="./css/style.css"/>
   
      
         
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-9B7KWQR3G9"></script>


      
      
      <title>slzr.cloud</title>
   </head>

   
      );
   }
   }

export default Header;
